export default __webpack_public_path__ + "static/media/contact-stairs-dark.0990bf6f.svg";